// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Hamburger Menu Styles */
.hamburger-menu-container {
  position: relative;
  width: 30px;
  height: 24px;
}

.hamburger-button {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 30px;
  height: 24px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 998;
  position: absolute;
  top: 0;
  right: 0;
}

.hamburger-button:focus {
  outline: 2px solid #d4a574;
  outline-offset: 2px;
  border-radius: 2px;
}

.hamburger-line {
  width: 100%;
  height: 3px;
  background-color: #d4a574;
  border-radius: 2px;
  transition: all 0.3s ease;
  transform-origin: center;
}

.hamburger-button.open .hamburger-line:nth-child(1) {
  transform: rotate(45deg) translate(8px, 8px);
}

.hamburger-button.open .hamburger-line:nth-child(2) {
  opacity: 0;
}

.hamburger-button.open .hamburger-line:nth-child(3) {
  transform: rotate(-45deg) translate(8px, -8px);
}

.hamburger-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.hamburger-menu {
  position: fixed;
  top: 0;
  right: 0;
  width: 280px;
  max-width: 85vw;
  height: 100vh;
  background-color: #1a1a1a;
  border-left: 1px solid #333;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.3);
  animation: slideIn 0.3s ease;
  overflow-y: auto;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

.hamburger-menu-header {
  padding: 20px;
  border-bottom: 1px solid #333;
  background-color: #222;
}

.hamburger-menu-close {
  position: absolute;
  top: 20px;
  right: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 24px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
}

.hamburger-menu-close:focus {
  outline: 2px solid #d4a574;
  outline-offset: 2px;
  border-radius: 2px;
}

.hamburger-menu-close .hamburger-line {
  position: absolute;
  width: 100%;
  height: 3px;
  background-color: #d4a574;
  border-radius: 2px;
  top: 50%;
  left: 0;
}

.hamburger-menu-close .hamburger-line:nth-child(1) {
  transform: translateY(-50%) rotate(45deg);
}

.hamburger-menu-close .hamburger-line:nth-child(2) {
  transform: translateY(-50%) rotate(-45deg);
}

.hamburger-menu .hamburger-menu-header .hamburger-button {
  top: 20px;
  right: 16px;
}

.hamburger-user-info {
  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;
  font-size: 14px;
  color: #d4a574;
  font-weight: 500;
}

.hamburger-menu-list {
  list-style: none;
  margin: 0;
  padding: 0;
  flex: 1;
}

.hamburger-menu-list li {
  border-bottom: 1px solid #2a2a2a;
}

.hamburger-menu-item {
  display: block;
  width: 100%;
  padding: 16px 20px;
  text-decoration: none;
  color: #e0e0e0;
  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;
  font-size: 16px;
  background: transparent;
  border: none;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.hamburger-menu-item:hover,
.hamburger-menu-item:focus {
  background-color: #2a2a2a;
  color: #d4a574;
  outline: none;
}

.hamburger-menu-item:active {
  background-color: #333;
}

.hamburger-menu-button {
  width: 100%;
  font-family: inherit;
  font-size: inherit;
}

/* Ensure menu is accessible on mobile */
@media (max-width: 768px) {
  .hamburger-menu {
    width: 100vw;
    max-width: 100vw;
  }
}
`, "",{"version":3,"sources":["webpack://./src/client/components/HamburgerMenu.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,QAAQ;AACV;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,4DAA4D;EAC5D,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,OAAO;AACT;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,4DAA4D;EAC5D,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,uDAAuD;AACzD;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA,wCAAwC;AACxC;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF","sourcesContent":["/* Hamburger Menu Styles */\n.hamburger-menu-container {\n  position: relative;\n  width: 30px;\n  height: 24px;\n}\n\n.hamburger-button {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  width: 30px;\n  height: 24px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  z-index: 998;\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n\n.hamburger-button:focus {\n  outline: 2px solid #d4a574;\n  outline-offset: 2px;\n  border-radius: 2px;\n}\n\n.hamburger-line {\n  width: 100%;\n  height: 3px;\n  background-color: #d4a574;\n  border-radius: 2px;\n  transition: all 0.3s ease;\n  transform-origin: center;\n}\n\n.hamburger-button.open .hamburger-line:nth-child(1) {\n  transform: rotate(45deg) translate(8px, 8px);\n}\n\n.hamburger-button.open .hamburger-line:nth-child(2) {\n  opacity: 0;\n}\n\n.hamburger-button.open .hamburger-line:nth-child(3) {\n  transform: rotate(-45deg) translate(8px, -8px);\n}\n\n.hamburger-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 999;\n  animation: fadeIn 0.2s ease;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.hamburger-menu {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 280px;\n  max-width: 85vw;\n  height: 100vh;\n  background-color: #1a1a1a;\n  border-left: 1px solid #333;\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.3);\n  animation: slideIn 0.3s ease;\n  overflow-y: auto;\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateX(100%);\n  }\n  to {\n    transform: translateX(0);\n  }\n}\n\n.hamburger-menu-header {\n  padding: 20px;\n  border-bottom: 1px solid #333;\n  background-color: #222;\n}\n\n.hamburger-menu-close {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 30px;\n  height: 24px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n}\n\n.hamburger-menu-close:focus {\n  outline: 2px solid #d4a574;\n  outline-offset: 2px;\n  border-radius: 2px;\n}\n\n.hamburger-menu-close .hamburger-line {\n  position: absolute;\n  width: 100%;\n  height: 3px;\n  background-color: #d4a574;\n  border-radius: 2px;\n  top: 50%;\n  left: 0;\n}\n\n.hamburger-menu-close .hamburger-line:nth-child(1) {\n  transform: translateY(-50%) rotate(45deg);\n}\n\n.hamburger-menu-close .hamburger-line:nth-child(2) {\n  transform: translateY(-50%) rotate(-45deg);\n}\n\n.hamburger-menu .hamburger-menu-header .hamburger-button {\n  top: 20px;\n  right: 16px;\n}\n\n.hamburger-user-info {\n  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;\n  font-size: 14px;\n  color: #d4a574;\n  font-weight: 500;\n}\n\n.hamburger-menu-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  flex: 1;\n}\n\n.hamburger-menu-list li {\n  border-bottom: 1px solid #2a2a2a;\n}\n\n.hamburger-menu-item {\n  display: block;\n  width: 100%;\n  padding: 16px 20px;\n  text-decoration: none;\n  color: #e0e0e0;\n  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;\n  font-size: 16px;\n  background: transparent;\n  border: none;\n  text-align: left;\n  cursor: pointer;\n  transition: background-color 0.2s ease, color 0.2s ease;\n}\n\n.hamburger-menu-item:hover,\n.hamburger-menu-item:focus {\n  background-color: #2a2a2a;\n  color: #d4a574;\n  outline: none;\n}\n\n.hamburger-menu-item:active {\n  background-color: #333;\n}\n\n.hamburger-menu-button {\n  width: 100%;\n  font-family: inherit;\n  font-size: inherit;\n}\n\n/* Ensure menu is accessible on mobile */\n@media (max-width: 768px) {\n  .hamburger-menu {\n    width: 100vw;\n    max-width: 100vw;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
